<template>
    <div>
        <div v-if="pendingFetch" :class="$style.emptyMessage">
            <div :class="$style.spinner"></div>
        </div>
        <div v-else-if="allJobs.length > 0" :class="$style.wrapper">
            <JobCard
                v-for="job in allJobs"
                :key="job.id"
                :job="job"
                :isJobDescOpen="isJobDescOpen"
                :currentlyOpenJobId="currentlyOpenJobId"
                @openJob="emitOpen(job)"
                :data-job-id="job.id"
            />
        </div>
        <div v-else :class="$style.emptyMessage">
            <p>😕 We can't find any matching open roles at the moment. Please try again later.</p>
        </div>
    </div>
</template>

<script>
import JobCard from './JobCard/JobCard.vue'

export default {
    name: 'JobList',
    components: {
        JobCard,
    },
    props: {
        isJobDescOpen: {
            type: Boolean,
            default: false,
        },
        currentlyOpenJobId: {
            type: Number,
            default: null,
        },
    },
    computed: {
        pendingFetch() {
            return this.$store.state.pendingAllJobs || this.$store.state.pendingJobFunctions
        },
        allJobs() {
            return this.$store.getters.jobQueryResult
        },
    },
    methods: {
        emitOpen(job) {
            this.$emit('openJobDescription', job)
        },
    },
}
</script>

<style module src="./JobList.css" />
